import { postGripperControl } from "../../ik/ikTarget/gripperControl";
import type { BTLeaf } from "../types";
import type { LeafContext, TickResult } from "./context";

function tickGripperWithSettle(
  ctx: LeafContext,
  node: Extract<BTLeaf, { kind: "openGripper" | "closeGripper" }>,
  mode: "open" | "close"
): TickResult {
  const lm = ctx.getLeafMem(node.id);
  const now = performance.now();
  if (!lm.gripperIssuedAtMs) {
    const r = postGripperControl(mode);
    if (!r.ok) {
      ctx.setFailureReason(
        mode === "open"
          ? "Open gripper failed: no active gripper controller."
          : "Close gripper failed: no active gripper controller."
      );
      return "failure";
    }
    const settleMs = Math.max(0, Number(node.settleSeconds) || 0) * 1000;
    lm.gripperIssuedAtMs = now;
    lm.gripperHoldUntilMs = now + settleMs;
  }
  if (now < (lm.gripperHoldUntilMs || 0)) {
    ctx.setActiveNode(node.id);
    return "running";
  }
  ctx.clearLeafMem(node.id);
  return "success";
}

export function tickOpenGripper(
  ctx: LeafContext,
  node: Extract<BTLeaf, { kind: "openGripper" }>
): TickResult {
  return tickGripperWithSettle(ctx, node, "open");
}

export function tickCloseGripper(
  ctx: LeafContext,
  node: Extract<BTLeaf, { kind: "closeGripper" }>
): TickResult {
  return tickGripperWithSettle(ctx, node, "close");
}
